import React, { useState } from "react";

const COACHING_FEATURES = [
  {
    ico: "🎯",
    title: "Personalised Health Goals",
    desc: "Your coach sets targets based on your medical history, lifestyle & skin-health profile",
  },
  {
    ico: "📅",
    title: "Weekly Check-ins & Accountability",
    desc: "Scheduled touchpoints to review progress and adapt your plan in real time",
  },
  {
    ico: "🥗",
    title: "Nutrition & Diet Guidance",
    desc: "Meal planning advice calibrated to Indian dietary habits and local food availability",
  },
  {
    ico: "🏃",
    title: "Structured Activity Programs",
    desc: "Step-by-step movement routines from beginner to advanced — tracked on the GOQii app",
  },
  {
    ico: "😴",
    title: "Sleep & Stress Management",
    desc: "Evidence-based techniques to improve sleep quality and reduce dermatological stress triggers",
  },
  {
    ico: "🧑‍⚕️",
    title: "Expert Advisory Layer",
    desc: "Coaches backed by GOQii's panel of health experts for escalation and second opinions",
  },
];

const BASE_FEATURES = [
  {
    ico: "🔬",
    name: "₹2,000 Diagnostics Wallet",
    val: "For all prescribed lab tests, annually",
  },
  {
    ico: "🧬",
    name: "65+ Tests Health Check-up",
    val: "One-time comprehensive health assessment",
  },
  {
    ico: "📱",
    name: "GOQii Wellness App",
    val: "Activity tracking, karma points & preventive tools",
  },
  {
    ico: "🏆",
    name: "Engagement & Gamification",
    val: "Live national leaderboards, state-wise rankings & quarterly challenges",
  },
];

export default function CommonBanner() {
  const [expanded, setExpanded] = useState(false);

  const visible = expanded ? COACHING_FEATURES : COACHING_FEATURES.slice(0, 3);

  return (
    <div className="common-banner">
      {/* ── Coaching Hero Block ── */}
      <div className="coaching-hero">
        <div className="coaching-hero-badge">Included in Every Plan</div>
        <div className="coaching-hero-title">
          Personalised Structured Lifestyle Management
        </div>
        <div className="coaching-hero-sub">
          Every GOQii plan comes with a <strong>dedicated human coach</strong> —
          not a chatbot — who builds and manages a structured lifestyle
          programme tailored specifically to you.
        </div>

        <div className="coaching-features-grid">
          {visible.map((f) => (
            <div className="cf-item" key={f.title}>
              <span className="cf-ico">{f.ico}</span>
              <div>
                <div className="cf-title">{f.title}</div>
                <div className="cf-desc">{f.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {!expanded && (
          <button
            className="coaching-expand-btn"
            onClick={() => setExpanded(true)}
          >
            See all coaching features ↓
          </button>
        )}
      </div>

      {/* ── Other Base Features ── */}
      <div className="cb-other-label">Also included in every plan</div>
      <div className="cb-grid">
        {BASE_FEATURES.map((f) => (
          <div className="cb-item" key={f.name}>
            <span className="cb-ico">{f.ico}</span>
            <div>
              <div className="cb-name">{f.name}</div>
              <div className="cb-val">{f.val}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
